import { observer } from 'mobx-react-lite'
import { EmptyState } from 'shared/ui'
import linkPreviewImg from 'shared/assets/images/clickToText/link_preview.png'
import { getCDNAssetURL } from 'shared/lib'
import {
  ClickToTextNewButton,
  ClickToTextHelpGuideButton,
} from 'pages/clickToText/pages/all/ui/ClickToTextButtons/ClickToTextButtons'
import styles from './styles.module.scss'

export const EmptyStateClickToText = observer(() => {
  return (
    <EmptyState
      variant={'preview'}
      previewImg={
        <img alt='Your text link is ready (preview)' src={getCDNAssetURL(linkPreviewImg)} />
      }
      title={'Create your first link'}
      subtitle={'Capture more contacts with scannable QR and links'}
      actions={
        <>
          <ClickToTextNewButton className={styles.newLinkButton} />
          <ClickToTextHelpGuideButton className={styles.helpGuideButton} />
        </>
      }
    />
  )
})
